export default "__VITE_ASSET__CmBjN8gV__"